module.exports = __webpack_public_path__ + "static/media/login_tips2.3f5e620d.png";